<section class="search-filters">
    {{ searchFilter.name }}
    <a href="" (click)="setVisible(title); false;" *ngFor="let title of searchFilter.titles" class="search-filters__link ml-3" 
    [ngClass]="{'search-filters__link--active': title == selectedSection}">{{ title }} 
        <!-- TODO: New icons from Andrew/Luca -->
        <mlp-ng-icon class="search-filters__icon" name="arrow-down-1"></mlp-ng-icon>
    </a>
    <section class="search-filters__section mt-2" [ngClass]="{'search-filters__section--hidden': !visible}">
        <form [formGroup]="searchFilter.form">
            <ng-container *ngFor="let radios of searchFilter.options">
                    <ng-container *ngFor="let radio of radios.filterOptions">

                        <mlp-ng-radio 
                            *ngIf="!radios.type" 
                            class="search-filters__label"
                            [formControlName]="radio.formControlName" 
                            [name]="radio.name" 
                            [radioValue]="radio.value" 
                            [ngClass]="{'d-none': radios.name != selectedSection}">{{ radio.label }}</mlp-ng-radio>
                        
                        <ng-container *ngIf="radios.type === 'calendar'">
                            <a class="sg-sf" (click)="method(radio.formControlName, ''); false;" [ngClass]="{'d-none': radios.name != selectedSection}">
                                <span class="sg-sf__indicator" [ngClass]="{'checked': searchFilter.form.controls[radio.formControlName].value === ''}"></span>
                                   All
                            </a>
                            
                            <mlp-ng-input-calendar class="search-filters__input" 
                                [ngClass]="{'d-none': radios.name != selectedSection, 'd-inline-block': radios.name == selectedSection}"
                                [formControlName]="radio.formControlName"
                                [input]="{ placeholder: 'Select date' }"></mlp-ng-input-calendar>

                        </ng-container>

                    </ng-container>
            </ng-container>
        </form>
    </section>
</section>
